import type { FC } from 'react';
import type { CardProps } from '@mui/material';
import React, { useState } from 'react';
import Link from './Link';
import {
  Button,
  Card,
  CardContent,
  Collapse,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography
} from '@mui/material';
import { Masonry } from '@mui/lab';

export interface PodcastCardProps extends CardProps {
  title?: string;
  body?: string;
  src?: string;
  href?: string;
  credits?: {
    title: string;
    roles?: {
      name: string;
      role: string;
    }[];
    names?: string[];
    name?: string;
  }[];
  transcript?: string;
}

const PodcastCard: FC<PodcastCardProps> = (props) => {
  const { title, body, src, credits, transcript, ...params } = props;

  const [open, setOpen] = useState<boolean>(false);

  const handleToggleOpen = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Card
      sx={{ my: 3 }}
      {...params}
    >
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <iframe className="pod-iframe" src={src} scrolling="no" title="episode-2" frameBorder="0"
              style={{ width: '100%', height: 102, marginBottom: 0, paddingBottom: 0 }}>
            </iframe>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography variant="h4" component="h2">{title}</Typography>
            {transcript && (
              <Button
                href={transcript}
                component={Link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mr: 2 }}
              >
                Transcript
              </Button>
            )}
            {credits && (
              <Button variant="outlined" onClick={handleToggleOpen}>
                {`${open ? 'Hide' : 'Show'} Details`}
              </Button>
            )}
            {credits && (
              <Collapse in={open}>
                <Divider sx={{ my: 2 }} />
                <Masonry columns={{ xs: 1, md: 2 }} spacing={3}>
                  {credits.map((credit) => (
                    <div>
                      <Typography variant="subtitle2" color="textSecondary">
                        {credit.title}
                      </Typography>
                      {(credit.roles || credit.names) && (
                        <List disablePadding>
                          {credit.roles && credit.roles.map((role) => (
                            <ListItem dense disablePadding>
                              <ListItemText
                                primary={role.role}
                                secondary={role.name}
                                primaryTypographyProps={{ variant: 'overline', gutterBottom: false }}
                                secondaryTypographyProps={{ variant: 'body2' }}
                              />
                            </ListItem>
                          ))}
                          {credit.names && credit.names.map((name) => (
                            <ListItem dense disablePadding>
                              <ListItemText
                                primary={name}
                                primaryTypographyProps={{ variant: 'body2', color: 'textSecondary' }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}
                      {credit.name && (
                        <Typography variant="body2" color="textSecondary">
                          {credit.name}
                        </Typography>
                      )}
                    </div>
                  ))}
                </Masonry>
              </Collapse>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PodcastCard;
